import getChatBySessionId from '../selectors/getChatBySessionId';
import InstantMessagePayload from 'owa-service/lib/contract/InstantMessagePayload';
import { addChatMessage } from '../actions/ucmaActions';
import { ChatMessageType } from '../store/schema/ChatMessageViewState';

export default function addChatMessageFromNotification(notification: InstantMessagePayload) {
    const chat = getChatBySessionId(notification.ChatSessionId);

    if (chat) {
        addChatMessage(
            chat,
            ChatMessageType.InstantMessage,
            notification.SipUri,
            notification.MessageContent
        );
    }
}
